import { render, staticRenderFns } from "./StammdatenImportDialog.vue?vue&type=template&id=e2df048a&scoped=true&"
import script from "./StammdatenImportDialog.vue?vue&type=script&lang=js&"
export * from "./StammdatenImportDialog.vue?vue&type=script&lang=js&"
import style0 from "./StammdatenImportDialog.vue?vue&type=style&index=0&id=e2df048a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../home/zarzar/Documents/public-solution/bis-office/web/zeitkontrolle/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2df048a",
  null
  
)

export default component.exports